import { A2kButton } from "./A2kButton.js";
window.customElements.define("a2k-button", A2kButton);
